export function is_super_admin_role(role) {
  const normalized_role = String(role || '')
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return normalized_role.includes('super admin');
}

export function is_super_admin() {
  return is_super_admin_role(localStorage.getItem('user_role'));
}

function parse_url(raw_url) {
  if (typeof raw_url !== 'string' || !raw_url.trim()) return null;
  try {
    return new URL(raw_url.trim());
  } catch {
    return null;
  }
}

//comment this out when pushing its for testing and testing only
// function is_loopback_http_url(url) {
//   if (!url || url.protocol !== 'http:') return false;
//   const hostname = String(url.hostname || '').toLowerCase();
//   if (hostname === 'localhost' || hostname.endsWith('.localhost')) return true;
//   return ['127.0.0.1', '::1'].includes(hostname);
// }

function is_https_url(url) {
  return Boolean(url && url.protocol === 'https:' && url.hostname);
}

export function is_safe_redirect_url(raw_url) {
  const url = parse_url(raw_url);
  if (!url) return false;
  if (url.username || url.password) return false;
  // return is_https_url(url) || is_loopback_http_url(url);
  return is_https_url(url);
}

export function safe_redirect_url(raw_url) {
  return is_safe_redirect_url(raw_url) ? parse_url(raw_url).toString() : '';
}
